<template lang="pug">
    section.prices-tab.not-translatable(v-if="activeTranslation")
        .panel
            .icon
                //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path class="fa-secondary" opacity=".4" d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 192c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/><path class="fa-primary" d="M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM192 192c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
                //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path class="fa-secondary" opacity=".4" d="M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM256 80c-13.3 0-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/><path class="fa-primary" d="M280 104c0-13.3-10.7-24-24-24s-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM459.9 448H96c-17.7 0-32-14.3-32-32V135.4L32 110.2V416c0 35.3 28.7 64 64 64H500.4l-40.5-32zM544 32H139.6l40.5 32H544c17.7 0 32 14.3 32 32V376.6l32 25.3V96c0-35.3-28.7-64-64-64zM423.3 256l40.5 32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H423.3zM144 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H257.2l-40.5-32H144zm160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h74.8l-40.5-32H304zm-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"/></svg>
            h4 {{ $t('Product prices are not translatable') }}
            p {{ $t('You should go to either the "Product" tab or the "Sub-Articles" tab') }}
    section.prices-tab(v-else)
        transition-group(name="slide-decent-vertical")
            template(v-for="(price, i) in form.prices")
                Price(
                    v-if="editPivot && getPivotPrice(price)"
                    :key="getPivotPrice(price).customerGroup.id"
                    :hide-special-prices="true"
                    :hide-net-value="!inheritedTax"
                    :inherited-tax="inheritedTax"
                    :form="valueOption.pivot"
                    :disabled-customer-group-ids="usedCustomerGroups.map(el => el.id)"
                    :rules="rules"
                    :price="getPivotPrice(price)"
                    :options-prop="options"
                    :autofocus="getPivotPrice(price).id === lastAddedPriceId"
                    @update="updatePrice"
                    @delete="event => deletePivotPrice(price)"
                )
                Price(
                    v-else
                    :key="price.customerGroup.id"
                    :hide-special-prices="true"
                    :hide-net-value="!inheritedTax"
                    :inherited-tax="inheritedTax"
                    :form="form"
                    :rules="rules"
                    :price="price"
                    :options-prop="options"
                    :autofocus="price.id === lastAddedPriceId"
                    :deletable="!editPivot"
                    :disabled="editPivot"
                    @update="updatePrice"
                    @delete="deletePrice"
                )
                    template(v-slot:button)
                        el-form-item(v-if="editPivot" label=" ")
                            //- v-if="deletable || price.type !== 'main'"
                            el-button.edit-price(
                                circle type="primary" plain size="mini"
                                icon="el-icon-fa-pencil fas"
                                @click="addPrice(price)"
                            )
            template(
                v-if="editPivot && pivotPrices"
                v-for="price in pivotPrices"
            )
                Price(
                    v-if="!getValueOptionPrice(price)"
                    :key="price.customerGroup.id"
                    :hide-special-prices="true"
                    :hide-net-value="!inheritedTax"
                    :inherited-tax="inheritedTax"
                    :form="valueOption.pivot"
                    :disabled-customer-group-ids="usedCustomerGroups.map(el => el.id)"
                    :rules="rules"
                    :price="price"
                    :options-prop="options"
                    :autofocus="price.id === lastAddedPriceId"
                    @update="updatePrice"
                    @delete="event => deletePivotPrice(price)"
                )

        .buttons(v-if="missingGroups.length")
            el-button(
                v-if="!editPivot && form.prices && form.prices.length"
                type="warning"
                @click="generateMissingGroupPrices"
            ) {{ $t('Generate missing customer group prices') }}
            el-button(
                type="primary"
                icon="el-icon-fa-plus fas"
                @click="event => addPrice()"
            ) {{ $t('Add price') }}
</template>

<i18n>
{
    "de": {
        "Consider generating the missing prices by clicking the button below.": "Die fehlenden Preise können per Klick auf die untere Schaltfläche generiert werden.",
        "Generate missing customer group prices": "Fehlende Kundengruppenpreise generieren",
        "Add price": "Preis hinzufügen"
    }
}
</i18n>

<script>
import Prices from '@/extensions/shop/views/Product/Form/Prices'

import Price from './Price';

import uniqid from 'uniqid';

export default {
    name: 'PricesTab',
    extends: Prices,
    props: {
        valueOption: {
            type: Object,
            required: true
        },
        optionsProp: {
            type: Object,
            required: true
        },

        editPivot: {
            type: Boolean,
            default: false
        },
        inheritedTax: {
            type: Object,
        },
    },
    data() {
        return {
            // The price the user just added; its gross field takes the focus.
            lastAddedPriceId: null,
        }
    },
    components: {
        Price,
    },
    computed: {
        form() {
            return this.valueOption;
        },
        options() {
            return this.optionsProp;
        },
        rules() {
            // let rules = {
            //     prices: []
            // }
            //
            // this.form.prices.forEach((price, index) => {
            //     if (price.type === 'main') {
            //         rules.prices.push({
            //             type: 'required',
            //             value: 'required|min_value:0',
            //             min_qty: 'required|integer|min_value:1',
            //             // start_at: 'required',
            //             // end_at: 'required',
            //             customerGroup: { id: 'required' },
            //             // tax: { value: 'required' }
            //         });
            //     } else {
            //         rules.prices.push({
            //             type: 'required',
            //             value: 'required|min_value:0',
            //             min_qty: 'required|integer|min_value:1',
            //             start_at: 'required',
            //             end_at: 'required',
            //             customerGroup: { id: 'required' },
            //             // tax: { value: 'required' }
            //         });
            //     }
            // })
            //
            // return rules
        },
        groupPrices() {
            let prices = this.form.prices || []
            if (this.editPivot) prices = this.pivotPrices

            return prices.filter(el => el.type === 'group' && el.customerGroup != null);
        },
        missingGroups() {
            // check if all customer groups have their own prices
            let missingGroups = [];

            const groups = this.options.customerGroup.items;
            if (groups.length) {
                let existingGroupIDs = this.groupPrices.map(el => el.customerGroup.id);
                missingGroups = groups.filter(el => !existingGroupIDs.includes(el.id));

                if (this.editPivot) {
                    const prices = this.form.prices || []
                    existingGroupIDs = prices.map(el => el.customerGroup.id);
                    missingGroups = missingGroups.filter(el => !existingGroupIDs.includes(el.id));
                }
            }

            return missingGroups;
        },
        usedCustomerGroups() {
            let usedCustomerGroups = []

            const groups = this.options.customerGroup.items;
            if (groups.length) {
                const missingGroupIDs = this.missingGroups.map(el => el.id);
                usedCustomerGroups = groups.filter(el => !missingGroupIDs.includes(el.id));
            }

            return usedCustomerGroups;
        },
        pivotPrices() {
            return _.get(this.valueOption, 'pivot.prices') || []
        }
    },
    methods: {
        generateMissingGroupPrices() {
            if (this.missingGroups && this.missingGroups.length) {
                this.missingGroups.forEach(customerGroup => {
                    this.addPrice({
                        id: uniqid('new:'),
                        value: _.get(this.form.prices[0], 'value'),
                        tax: _.get(this.form.prices[0], 'tax'),
                        tax_rate: _.get(this.form.prices[0], 'tax_rate'),
                        type: 'group',
                        customerGroup,
                        start_at: null,
                        end_at: null
                    });
                });
            }
        },
        addPrice(price = null) {
            if (!price) {
                price = {
                    id: uniqid('new:'),
                    value: 1,
                    tax: undefined,
                    tax_rate: 'inherit',
                    type: 'group',
                    customerGroup: this.activeShop.defaultCustomerGroup,
                    start_at: null,
                    end_at: null
                }

                let prices = this.form.prices || []
                if (this.editPivot && _.get(this.valueOption, 'pivot.prices.length')) {
                    prices = this.valueOption.pivot.prices
                }

                if (prices.length) {
                    // price.type = 'group'
                    price.value = _.get(prices[0], 'value')
                    price.customerGroup = this.missingGroups[0]
                }
            } else {
                price = _.cloneDeep(price)
                price.id = uniqid('new:')
            }

            // Marked for one render: the row would otherwise take the focus again every
            // time it re-mounts, e.g. when its customer group is changed.
            this.lastAddedPriceId = price.id
            this.$nextTick(() => {
                this.lastAddedPriceId = null
            })

            if (this.editPivot) {
                if (!this.valueOption.pivot) {
                    this.$set(this.valueOption, 'pivot', {
                        id: uniqid('new:'),
                        prices: [],
                    })
                }

                if (!this.valueOption.pivot.prices) {
                    this.$set(this.valueOption.pivot, 'prices', [])
                }

                const i = this.valueOption.pivot.prices.length
                this.$set(this.valueOption.pivot.prices, i, price)
            } else {
                if (!this.valueOption.prices) {
                    this.$set(this.valueOption, 'prices', [])
                }

                const i = this.valueOption.prices.length
                this.$set(this.valueOption.prices, i, price)
            }
        },
        updatePrice({ price, field, value }) {
            this.$set(price, field, value)
        },
        deletePrice({ index }) {
            if (this.form.prices && this.form.prices.length) {
                // this.form.prices.splice(index, 1)
                this.$delete(this.form.prices, index)
            }
        },
        getValueOptionPrice(price) {
            const prices = _.get(this.valueOption, 'prices') || []
            return prices.find(el => el.customerGroup.id === price.customerGroup.id)
        },
        getPivotPrice(price) {
            const prices = _.get(this.valueOption, 'pivot.prices') || []
            return prices.find(el => el.customerGroup.id === price.customerGroup.id)
        },
        deletePivotPrice(price) {
            const index = this.pivotPrices.findIndex(el => el.customerGroup.id === price.customerGroup.id)
            if (index >= 0) this.$delete(this.valueOption.pivot.prices, index)
        },
    }
}
</script>
